/**
 * Shared vocabulary for the Mobile Billing App register: the statuses an APK entry can
 * carry, and the link handling the list, the dialog and the share email all rely on.
 */

export const APK_STATUSES = [
    { label: 'Active',   value: 'Active',   icon: 'pi pi-check-circle', tone: 'success' },
    { label: 'Inactive', value: 'Inactive', icon: 'pi pi-times-circle', tone: 'danger'  }
];

/** Dropdown options — label/value only. */
export const STATUS_OPTIONS = APK_STATUSES.map(({ label, value }) => ({ label, value }));

/** Older rows may have been written as 'InActive'; treat that as 'Inactive' everywhere. */
export const normalizeStatus = (status) => {
    const value = String(status || '').trim();
    return value.toLowerCase() === 'inactive' ? 'Inactive' : value || 'Active';
};

export const statusTone = (status) => APK_STATUSES.find((s) => s.value === normalizeStatus(status))?.tone || 'secondary';

export const countByStatus = (rows, status) => rows.filter((row) => normalizeStatus(row.status) === status).length;

/**
 * A Google Drive share link rewritten into one that downloads the file instead of
 * opening the viewer. Recognises the /file/d/<id>/ and ?id=<id> forms; anything else
 * (a folder link, a plain URL) is handed back untouched.
 *
 * The backend applies the same rewrite for its own redirect and for the share email —
 * this copy is what lets the list show and validate the resolved link without a round trip.
 */
export const toDirectDownloadUrl = (link) => {
    const url = String(link || '').trim();
    if (!url) return '';
    const match = url.match(/\/file\/d\/([a-zA-Z0-9_-]{10,})/) || url.match(/[?&]id=([a-zA-Z0-9_-]{10,})/);
    return match ? `https://drive.google.com/uc?export=download&id=${match[1]}` : url;
};

/** True when the row has something to download or install — drives the action buttons. */
export const hasDownload = (row) => Boolean(String(row?.googledrive_link || '').trim() || String(row?.play_storelink || '').trim());

/** 'YYYY-MM-DD HH:mm:ss' -> 'dd/mm/yyyy hh:mm'. Blank stays blank. */
export const formatDisplayDate = (value) => {
    if (!value) return '';
    const date = new Date(String(value).replace(' ', 'T'));
    if (isNaN(date.getTime())) return String(value);
    const pad = (n) => String(n).padStart(2, '0');
    return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
};
